import { Component } from '@angular/core';
import { PromotionInfoBaseComponent } from '../promotion-info-base.component';
import { CommonModule } from '@angular/common';
import { QuantityUnitToStringPipe } from 'projects/shared/lib/pipes/quantity-unit/quantity-unit-to-string.pipe';

@Component({
  selector: 'app-promotion-info-short',
  imports: [
    CommonModule,

    QuantityUnitToStringPipe
  ],
  templateUrl: './promotion-info-short.component.html',
  styleUrls: ['./promotion-info-short.component.scss']
})
export class PromotionInfoShortComponent extends PromotionInfoBaseComponent {
}
